export const GET_IRRIGATION = 'Get_Irrigation';